import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useI18n } from '../lib/i18n';
import { Field } from '../components/ui';
import { useTheme } from '../lib/theme';
import markDark from '../assets/proactive-mark-dark.png';
import markWhite from '../assets/proactive-mark-white.png';

export function PlatformLogin() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const { t } = useI18n();
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await api.post('/api/auth/platform/login', { email, password });
      await refresh();
      nav('/platform');
    } catch (err) {
      setError(err instanceof ApiError && err.status === 401 ? t('auth.invalidCreds') : t('auth.error'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card">
        <div className="auth-brand">
          <img src={theme === 'dark' ? markWhite : markDark} alt="Proactive" className="brand-mark-img" />
          <strong>{t('auth.platformConsole')}</strong>
        </div>
        <div className="auth-title">{t('auth.platformTitle')}</div>
        <div className="auth-sub">{t('auth.platformSub')}</div>
        <form onSubmit={submit}>
          <Field label={t('auth.email')} type="email" value={email} onChange={setEmail} />
          <Field label={t('auth.password')} type="password" value={password} onChange={setPassword} />
          {error && <div className="error">{error}</div>}
          <button className="btn" style={{ width: '100%' }} disabled={busy}>
            {busy ? '…' : t('auth.enter')}
          </button>
        </form>
      </div>
    </div>
  );
}
